// extracted by mini-css-extract-plugin
export default {"full-width-video":"Ly-dEgLkho9MfhiQ80xT9w==","full-width-video__container":"ulyIADATTVMEDThnuTlSFA==","full-width-video__inner-container":"KDP-wGQ530yN0NNOoqPvIQ=="};